import React, { createContext, useCallback, useContext, useState } from 'react';
import { useFeatureGate } from 'src/debug/feature-gate/FeatureGatesContext';
import { FEATURE_GATE_UPLOAD_AND_PRINT_PROGRESSIVE_VALIDATION } from '../debug/feature-gate/gates';

export interface ClientValidationContextProps {
  isClientValidationEnabled: boolean;
  setClientValidation: (enabled: boolean) => void;
}

export const ClientValidationContext = createContext<ClientValidationContextProps>({
  isClientValidationEnabled: true,
  setClientValidation: () => undefined,
});

export interface ClientValidationProviderProps {
  children?: React.ReactNode;
}

export const ClientValidationProvider = ({ children }: ClientValidationProviderProps): React.ReactElement => {
  const { isEnabled: isProgressiveValidationEnabled } = useFeatureGate(
    FEATURE_GATE_UPLOAD_AND_PRINT_PROGRESSIVE_VALIDATION
  );
  const [isClientValidationEnabled, setIsClientValidationEnabled] = useState<boolean>(isProgressiveValidationEnabled());

  const setClientValidation = useCallback((enabled: boolean) => {
    setIsClientValidationEnabled(enabled);
  }, []);

  return (
    <ClientValidationContext.Provider value={{ isClientValidationEnabled, setClientValidation }}>
      {children}
    </ClientValidationContext.Provider>
  );
};

export const useClientValidation = () => {
  return useContext(ClientValidationContext);
};
